/**
 * Possible Ticket Queue Status.
 */
export enum ClickUpTicketStatus {
	EmAberto = "EM ABERTO"
}
